module.exports = __webpack_public_path__ + "img/qu_au.e0fe7ac.jpg";